// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"399":"be733e64862d0dbb","2888":"1fe33382966a9f5c"}[chunkId] + ".css";
};